import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { endpoint } from "../../api/endpoint";
import {
  saveAuthData,
  saveModule,
  saveRole,
  saveUserData,
} from "../../features/login/LoginSlice";
import { apiHandler } from "../../api";
import Joi from "joi";
import { useNavigate } from "react-router";

export const useAuthPage = () => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const authToken = useSelector(
    (state) => state.loginSlice.authData?.accessToken
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const auth = JSON.parse(queryParams.get("auth"));
    const navbar = queryParams.get("navbar")
      ? JSON.parse(queryParams.get("navbar"))
      : [];
    const userDetails = JSON.parse(queryParams.get("authorization"));
    // console.log("queryParams", userDetails);

    const secondAppUrl = `${process.env.REACT_APP_SAAS_URL}/login`;

    if (!authToken && !auth) {
      const redirectUrl = window.location.origin + window.location.pathname;
      const applicationName = "Sandbox";

      window.location.href = `${secondAppUrl}?redirectUrl=${encodeURIComponent(
        redirectUrl
      )}&appName=${encodeURIComponent(applicationName)}`;
    } else {
      dispatch(
        saveAuthData({
          accessToken: auth?.accessToken,
          refreshToken: auth?.refreshToken,
        })
      );
      dispatch(saveRole("Admin"));
      dispatch(saveModule(navbar));
      dispatch(saveUserData(userDetails));

      navigate("/productsandbox");
    }
  }, [authToken]);

  const schema = Joi.object({
    username: Joi.string()
      .email({ tlds: { allow: ["com", "net", "org", "edu", "gov"] } })
      .required()
      .messages({
        "string.email": "Please enter a valid email address.",
        "string.email.tlds":
          "The domain must be one of the following: .com, .net, .org, .edu, .gov.",
        "string.empty": "Email is required.",
      }),
    password: Joi.string()
      .min(8)
      .pattern(new RegExp("^(?=.*[A-Z])(?=.*[!@#$%^&*])"))
      .required()
      .messages({
        "string.min": "Password must be at least 8 characters long.",
        "string.pattern.base":
          "Password must contain at least one uppercase letter and one special character.",
        "string.empty": "Password is required.",
      }),
  });

  const validate = () => {
    const { error } = schema.validate(
      { username, password },
      { abortEarly: false }
    );

    if (error) {
      const errorMessages = {};
      error.details.forEach((item) => {
        errorMessages[item.path[0]] = item.message;
      });
      setErrors(errorMessages);
      return false;
    }

    setErrors({});
    return true;
  };
  const navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (validate()) {
      setLoading(true);
      try {
        const response = await apiHandler({
          url: endpoint.LOGIN,
          method: "POST",
          data: {
            sEmail: username,
            sPassword: password,
          },
          dispatch,
        });

        if (response.data.status === "success") {
          dispatch(saveAuthData(response.data.data.accessToken));
          dispatch(saveRole(response.data.data.role));
          dispatch(saveModule(response.data.data.module));
          navigate("/");
        } else {
          addToast(response.data.message, {
            appearance: "error",
            autoDismiss: true,
          });
        }
      } catch (error) {
        console.log(error);

        addToast("An error occurred while logging in. Please try again.", {
          appearance: "error",
          autoDismiss: true,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return {
    setUsername,
    setPassword,
    handleSubmit,
    errors,
    loading,
  };
};
